const E = {
  'Sample ID': 'Sample ID',
  Matrix: 'Matrix',
  'Additional Samples': 'Additional Samples',
  'Total Samples': 'Total Samples',
};

const F = {
  'Sample ID': 'ID de l’échantillon',
  Matrix: 'Matrice',
  'Additional Samples': 'Échantillons supplémentaires',
  'Total Samples': 'Nombre total d’échantillons',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/formsOrderSummaryDesktopSampleIDs.js